// extracted by mini-css-extract-plugin
export default {"root":"AddNewButton_root__cZHPn"};